import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs as saveByFileSaver } from "file-saver";
import { ConfirmationService, SelectItem } from 'primeng/api';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { APGTestingService } from './apgtesting.service';
import { CovidSamples } from './model/covid-sample';
import { Covid19Batch, FilesPerManufacturer, RunLane, WellType } from './model/covid19Batch';
import { KitsDTO } from '../masterdata/models/kits-dto';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Comment } from './model/comment';
import { MergedBatch } from './model/merged-batch';
import {  SelectableLab } from '../masterdata/models/lab';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { BatchGroup } from './model/batchGroup';
import { BatchItemHistory } from './model/batchItemHistory';
import { DatePipe } from '@angular/common';

import { APGCovid19Constants } from './model/apg-newview-constants';
import { PlateViewComponent } from '../plate-view/plate-view.component';
import { Tags } from '../masterdata/models/tags';
import { ActivatedRoute } from '@angular/router';
import { BBResponseContainer } from '../common-services/response-container';

@Component({
  selector: 'app-agptesting-newview',
  templateUrl: './agptesting-newview.component.html',
  styleUrls: ['./agptesting-newview.component.css']
})
export class AgptestingNewviewComponent implements OnInit {

  
  
  @ViewChild('focus1',{static : false})
  searchElement1: ElementRef;

  @ViewChild('focus2',{static : false})
  searchElement2: ElementRef;

  @ViewChild('focus3',{static : false})
  searchElement3: ElementRef;

  @ViewChild('plateView',{static : false})
  plateViewCmp: PlateViewComponent;
  
  readonly buttonsRound= {"margin-bottom": "5px",
  "margin-top": "5px",
  "font-weight": "bold",
  "font-size": "14px",
  "padding": "7px",
  "width":"96%",
  "border-radius":"5px",
  "border-color": "#83b8e6",
  "background-color": "#83b8e6"
  }
  batches: Covid19Batch[] = [];
  kitsDTO: KitsDTO;
  fileNameString: string = '';
  selectedBatch: Covid19Batch;
  puid: string;
  uploadForm: FormGroup;
  val2: string;
  val1: boolean;
  option1: boolean;
  option2: boolean;
  option3: boolean;
  batchToSearch: string;
  sampleToSearch: string;
  showBatch = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  allowCreate: boolean = false;
  color: string;
  selectedLabId: string;
  isUploadDisabled = true;
  senderList: any[] = [];
  exctractionMachines: any[] = [];
  extractionKitVendorList: any[] = [];
  kitVendorList: any[] = [];
  rtkitVendorList: any[] = [];
  chemicalList: any[] = [];
  chemicalListPCR: any[] = [];
  chemicalMap = new Map();
  chemicalMapWithCovidBatchValues = new Map();
  rtPCRKitVendorList: any[] = [];
  lightCyclers: any[] = [];
  selectedResetStatus: string;
  mapOfStatus = new Map();
  mapOfStatusSaves = new Map();
  showPlateView = false;
  puidValidate: boolean;
  resultResponse: string;
  plateViewData: CovidSamples[] = [];
  plateViewDataFetched = false;
  plateMap = new Map();
  sampleBatch1Map = new Map();
  sampleBatch2Map = new Map();
  sampleBatch3Map = new Map();
  sampleBatch4Map = new Map();
  display: boolean = false;
  displayPCR: boolean = false;
  statusAtKitLot: boolean = false;
  statusAtCpValue: boolean = false;
  mapOfKits = new Map();
  public map = new Map<string, string>();
  public mapOfCpValue = new Map<string, string>();
  viewPlateIcon: string = "fa fa-th"
  NTCOk = false;
  IPCOk = false;
  plateOne: string;
  plateTwo: string;
  plateThree: string;
  plateFour: string;
  sampleBatch1: CovidSamples[] = [];
  sampleBatch2: CovidSamples[] = [];
  sampleBatch3: CovidSamples[] = [];
  sampleBatch4: CovidSamples[] = [];
  sampleBatch1PosControlsPositions: string[] = [];
  sampleBatch2PosControlsPositions: string[] = [];
  sampleBatch3PosControlsPositions: string[] = [];
  sampleBatch4PosControlsPositions: string[] = [];
  sampleBatch1PosControlsPositionsturned: string[] = [];
  sampleBatch2PosControlsPositionsturned: string[] = [];
  sampleBatch3PosControlsPositionsturned: string[] = [];
  sampleBatch4PosControlsPositionsturned: string[] = [];
  backGroundColor: string;
  circleBorder: string;
  crossWidth: string;
  crossColor: string;
  circleStroke: string;
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

  columnHeaders96Odd = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  rowHeaders96Odd = ['A', 'C', 'E', 'G', 'I', 'K', 'M', 'O'];

  columnHeaders96Even = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  rowHeaders96Even = ['B', 'D', 'F', 'H', 'J', 'L', 'N', 'P'];

  controlArray = ['POS_EX', 'NTC_EX', 'PCR-PC', 'PCR-NTC'];

  isLoadStandardPrimerPlate: boolean = false;
  myFiles: string[] = [];
  ixoFiles: string[] = [];
  isResultUploadDisabled: boolean = true;
  missingBarcodesList: string[];
  samplePopVisible = false;
  selectedSample: CovidSamples = new CovidSamples();
  isResultGroup: boolean = false;
  resultGroupMap: Map<string, any> = new Map<string, any>();
  samplePosition = '';
  sampleType = '';
  tempSampleComment: string;
  tempSampleInvalid: boolean;
  tempSampleResult: string;
  tempICRResult: boolean;
  sampleResultOptions: SelectItem[] = [];
  sampleResultOptionsWithoutPositive: SelectItem[] = [];
  icrPresentInKit = false;
  icrResultOptionsNormal = [
    { value: true, label: 'Positive' },
    { value: false, label: 'Negative' }
  ];
  icrResultOptionsNegative = [
    { value: true, label: 'Negative' },
    { value: false, label: 'Positive' }
  ];
  positiveControlResultOptions = [
    { value: 'positive', label: 'Passed' },
    { value: 'negative', label: 'Failed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' }
  ];
  resultGroupControlResultOptions = [
    { value: 'positive', label: 'Positive' },
    { value: 'negative', label: 'Negative' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' },
    { value: 'retest', label: 'Retest' },
  ];
  negativeControlResultOptions = [
    { value: 'positive', label: 'Failed' },
    { value: 'negative', label: 'Passed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' }
  ];
  uploadedTxtFiles: string[] = [];
  uploadedxlsxFiles: string[] = [];
  uploadedPCRDFiles: string[] = [];
  uploadedXMLFiles: string[] = [];
  uploadedCSVFiles: string[] = [];
  bioradLimsFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  fastFinderFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  filetypes: Array<string> = ['ixo', 'txt', 'xml', 'csv'];
  readonly emptyGeneName = 'Empty';
  gene: string = this.emptyGeneName;
  allChecksResolved = true;
  dominantChannelName: string;

  finalStatusList = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' },
    { label: 'Check', value: 'Check' }
  ];

  finalStatusListWithoutLysis = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Check', value: 'Check' }
  ];

  statusSelectionList = [
    { label: 'Start Clipping', value: 'START_CLIPPING' },
    { label: 'Complete Clipping', value: 'COMPLETE_CLIPPING' },
    { label: 'Start Lysis', value: 'START_LYSIS' },
    { label: 'Complete Lysis', value: 'COMPLETE_LYSIS' },
    { label: 'Verify Reception', value: 'SAMPLE_RECEPTION_CHECKED' },
    { label: 'Start Extraction', value: 'START_EXTRACTION' },
    { label: 'Start Extractor', value: 'START_EXTRACTOR' },
    { label: 'Complete Extraction', value: 'EXTRACTION_COMPLETE' },
    { label: 'Start Precycling', value: 'START_PRECYCLING' },
    { label: 'Complete Precycling', value: 'COMPLETE_PRECYCLING' },
    { label: 'Start Cycling', value: 'START_CYCLING' },
    { label: 'Completed Cycling', value: 'CYCLER_COMPLETE' },
    { label: 'Start Analysis', value: 'ANALYSIS_STARTED' },
    { label: 'Complete Analysis', value: 'ANALYSIS_DONE' },
    { label: 'Result Files Sent', value: 'COMPLETED' },
    { label: 'Remove Batch', value: 'REMOVED' }
  ];


  groupedBatches: BatchGroup[] = [];
  batchHistoryId : string;
  batchHistory: any[] = [];

  // table properties and values
  processSteps: any[];
  filterOptions: any[];
  selectedStates: string[] = [];
  blocked = false;
  loading: boolean;
  fromDate: Date;
  toDate: Date;

  // Scan related properties
  scanTableArray: CovidSamples[] = [];
  scannedControls: CovidSamples[] = [];
  showSampleErrorPopUp = false;
  scannedSampleErrorMessage = '';
  currentScanCell = 0;
  scanAllowedStates = ['SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'];
  mapOfScannedBarcodes: Map<string, string>;
  scanTableBackupMap: Map<string, CovidSamples>;

  posControlsForLab: number;
  negativeControlForLab: number;
  posControlsRemaining: number;
  negativeControlRemaining: number;

  activateSaveScan = false;
  contaminationPopUp = false;
  scannedBarcode = '';
  showDifferentUnboxedErrorPopUp = false;
  differentUnboxedErrorDisabled = false;
  dirty = false;
  scanDialogMessage = 'Scan RNA Plate changes not yet saved. Do you wish to proceed?';
  redoDialogMessage = 'Are you are sure to do the redo?';
  scanBlock = false;
  sameScanBatch = false;
  saveScanErrorHeader = '';
  saveScanErrorBody = '';

  verifyReceptionPUID = false;
  verifyUndoMergePUID = false;
  showFilledTemplateLabel: boolean = false;
  storage: string;
  enteredPuid: string;
  enteredPassword: string;
  enteredScanPlateBarcode: string;
  enteredPasswordToByeArray: any[];
  puidPopup: boolean = false;
  puidPopupFunction: string;
  counter: number;

  previewComment: Comment;
  showCommentDialog = false;
  commentsMap = new Map<string, Comment[]>();
  newComment: Comment;
  batchCommentVisibility: Map<string, boolean>;

  refStatusOfPrev: string;
  boxColor: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedMergedBatch: MergedBatch;
  redoReasons: any[];
  machineShortInfos = new Map<string, string>();
  machineIOCapcity = new Map<string, string>();

  changedSampleList: CovidSamples[] = [];
  showAnalysisDialog = false;
  columnList: any[] = [];
  analysisVerifyPUID: string = null;
  commentPopup = false;
  externalFileTransferEnabled = false;
  mapOfSenders = new Map<string, any>();

  selectedLab: any;
  dateFormat:string;
  isIXOMandatory = false;

  bioRadMachineTypes = ["biorad", "biorad_dk"];
  mapOfMachineInfo = new Map<string, any>();
  selectedSender: SenderDTO;
  selectedExtractor: any;

  sampleHistoryMap: any;
  batchHeaders: string[] = [];
  selectedSampleHistoryMap: Map<string, Object> = null;

  reset: any[] = [{}];

  headerIndex = 0;
  analysisAndUpwardsStatuses = ['ANALYSIS_STARTED', 'ANALYSIS_DONE', 'REDO', 'DATA_READY', 'COMPLETED'];
  subSender = new Set();
  subSenderForPlateOne = new Set();
  subSenderForPlateTwo = new Set();
  subSenderForPlateThree = new Set();
  subSenderForPlateFour = new Set();
  colorSenderMap = new Map();
  colours = ['#ffb3b3', '#9999e6', '#ff80ff', '#a6a6a6', '#ff5050', '#33cccc', '#80ff80', '#ffaa00', '#0099ff', '#888844'];
  reportingOutsideBB = true;
  manufacturerConfigMap = new Map<string, any>();
  fileTypeCountMap = new Map<string, number>();
  manufacturerFileMandatoryMap = new Map<string, any>();
  filesPerManufacturerMap = new Map<string, FilesPerManufacturer[]>();
  missingFilesPopUp: boolean = false;
  missingPatterns: any[];
  totalPCRControls: number;
  selectableLab: SelectableLab;
  archiveBatchOptions: any[];
  selectedArchiveOption: string;
  mapOfTags = new Map();
  mapOfPlannedTags = new Map();
  mapOfTagsFromMDM = new Map();
  tags: any[] = [];
  tagsList : any[] = [];
  cachedTags: any[] = [];
  cachedTagsList : any[] = [];
  selectedTagPlate: string;
  dillusionFactorForArticQC: number = 1;
  dillusionFactorForLibQC: number = 1;
  showFilter: boolean = true;
  searchFilterList:any[];
  selectedSearchFilter:any;
  valueToSearch : string;
  fieldBatchID:string = "BatchId";
  analysisPlateView: boolean = false;
  tagObj : Tags;
  mapOfQCBatchView = new Map();
  batchIdFromDelivery: any;
  selectedQCFailedBatch: Covid19Batch;
  controlPosition:string;
  processBatchControl:boolean;
  pcrPosition:string;
  dirtyChild = false;

  plateViewMode = "ARTIC_PLATE_VIEW_MODE";
  dateTimeFormat: string;

  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService, 
    private formBuilder: FormBuilder, private confirmationService: ConfirmationService, 
    private masterDataService: MasterDataService, public datepipe: DatePipe, private activatedRoute: ActivatedRoute) { }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    if (this.dirty || this.dirtyChild) {
      event.returnValue = false;
    }
  }

  canDeactivate() {
    if (this.dirty) {
      return confirm(this.scanDialogMessage);
    } else if(this.dirtyChild){
      return confirm("You are leaving the manual qc review mode without saving the changes. Click OK to discard the changes. Click Cancel to continue manual qc review.");
    } else {
      return true;
    }
  }
  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }

  ngOnInit() {

    this.selectedBatch = new Covid19Batch();
    this.previewComment = new Comment();
    this.commentsMap = new Map<string, Comment[]>();
    this.newComment = new Comment();
    this.batchCommentVisibility = new Map<string, boolean>();
    this.selectedBatch.sender = '';
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.dateFormat =this.setDateFormat(this.selectableLab.lab.dateFormat.toLowerCase());
    this.dateTimeFormat = this.selectableLab.lab.dateTimeFormat
    this.selectedLabId = this.selectableLab.lab._id;

    this.reportingOutsideBB = this.selectableLab.lab.reportingOutsideBB;
    this.findControlesDetails();

    this.puid = localStorage.getItem('PUID');
    this.showAnalysisDialog = false;
    this.populateSenders();
    
    this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe(
      results => {
        this.batches = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )

    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });

    this.filterOptions = [
      { label: 'Upload Batch', value: "BATCH_UPLOADED" },
      { label: 'Receive Batch', value: "BATCH_RECEIVED" },
      { label: 'Controls Added', value: "CONTROLS_ADDED" },
      { label: 'Start cDNA', value: "START_cDNA" },
      { label: 'Complete cDNA', value: "COMPLETE_cDNA" },
      { label: 'Start Artic PCR', value: "START_ARTIC_PCR" },
      { label: 'Complete Artic PCR', value: "COMPLETE_ARTIC_PCR" },
      { label: 'Start ARTIC Pooling', value: "START_ARTIC_POOLING" },
      { label: 'Complete ARTIC Pooling', value: "COMPLETE_ARTIC_POOLING" },
      { label: 'Start ARTIC Purification', value: "START_ARTIC_PURIFICATION" },
      { label: 'Complete ARTIC Purification', value: "COMPLETE_ARTIC_PURIFICATION" },
      { label: 'Start Artic QC', value: "START_ARTIC_QC" },
      { label: 'Complete Artic QC', value: "COMPLETE_ARTIC_QC" },
      { label: 'Start Normalization', value: "START_NORMALIZATION" },
      { label: 'Complete Normalization', value: "COMPLETE_NORMALIZATION" },
      { label: 'Start End Repair', value: "START_END_REPAIR" },
      { label: 'Complete End Repair', value: "COMPLETE_END_REPAIR" },
      { label: 'Start Adapter Ligation', value: "START_ADAPTER_LIGATION" },
      { label: 'Complete Adapter Ligation', value: "COMPLETE_ADAPTER_LIGATION" },
      { label: 'Start Purification 2', value: "START_PURIFICATION_2" },
      { label: 'Complete Purification 2', value: "COMPLETE_PURIFICATION_2" },
      { label: 'Start Tag PCR', value: "START_TAG_PCR" },
      { label: 'Complete Tag PCR', value: "COMPLETE_TAG_PCR" },
      { label: 'Start Lib QC', value: "START_LIB_QC" },
      { label: 'Complete Lib QC', value: "COMPLETE_LIB_QC" },
      { label: 'Start Lib Pooling', value: "START_LIB_POOLING" },
      { label: 'Complete Lib Pooling', value: "COMPLETE_LIB_POOLING" },
      { label: 'Start Final QC', value: "START_FINAL_QC" },
      { label: 'Complete Final QC', value: "COMPLETE_FINAL_QC" },
      { label: 'Transfer To Sequencing', value: "TRANSFER_SEQUENCING" },
      { label: 'Start Sequencing Run', value: "START_SEQUENCING_RUN" },
      { label: 'Complete Sequencing Run', value: "COMPLETE_SEQUENCING_RUN" },
      { label: 'Start Primary Analysis', value: "START_PRIMARY_ANALYSIS" },
      { label: 'Complete Primary Analysis', value: "COMPLETE_PRIMARY_ANALYSIS" },
      { label: 'Start Secondary Analysis', value: "START_SECONDARY_ANALYSIS" },
      { label: 'Complete Secondary Analysis', value: "COMPLETE_SECONDARY_ANALYSIS" },
      { label: 'Start Data Review', value: "START_DATA_REVIEW" },
      { label: 'Ready For Delivery', value: "READY_FOR_DELIVERY" },
      { label: 'Start Delivery', value: "START_DELIVERY" },
      { label: 'Delivered', value: "COMPLETED" },
      { label: 'Invoiced', value: "INVOICED" },
      { label: 'Redo', value: "REDO" },
      { label: 'Removed', value: "REMOVED" },
      { label: 'Archived', value: "ARCHIVED" }
    ];

    this.mapOfStatus.set('Batch Reception', ["CREATE_BATCH", "SCAN_COMPLETE", "BATCH_UPLOADED"]);
    this.mapOfStatus.set('ARTIC PCR', ["BATCH_RECEIVED", "CONTROLS_ADDED", "START_cDNA", "COMPLETE_cDNA", "START_ARTIC_PCR"]);
    this.mapOfStatus.set('ARTIC QC', ["COMPLETE_ARTIC_PCR", "START_ARTIC_POOLING", "COMPLETE_ARTIC_POOLING", "START_ARTIC_QC", "COMPLETE_ARTIC_QC", "START_NORMALIZATION"]);
    this.mapOfStatus.set('Lib Prep pre-PCR', ["COMPLETE_NORMALIZATION", "START_PURIFICATION_1", "COMPLETE_PURIFICATION_1", "START_END_REPAIR", "COMPLETE_END_REPAIR", "START_ADAPTER_LIGATION", "COMPLETE_ADAPTER_LIGATION", "START_PURIFICATION_2", "COMPLETE_PURIFICATION_2", "START_TAG_PCR"]);
    this.mapOfStatus.set('Lib Prep post-PCR', ["COMPLETE_TAG_PCR", "START_PURIFICATION_3", "COMPLETE_PURIFICATION_3", "START_LIB_QC", "COMPLETE_LIB_QC", "START_LIB_POOLING"]);
    this.mapOfStatus.set('Sequencing', ["COMPLETE_LIB_POOLING", "TRANSFER_SEQUENCING", "START_SEQUENCING_RUN"]);

    this.sampleResultOptions = [
      { value: 'positive', label: 'Positive' },
      { value: 'negative', label: 'Negative' },
      { value: 'check', label: 'Check' },
      { value: 'ambiguous', label: 'Ambiguous' },
      { value: 'invalid', label: 'Invalid' }
    ];

    this.sampleResultOptionsWithoutPositive = [
      { value: 'negative', label: 'Negative' },
      { value: 'check', label: 'Check' },
      { value: 'ambiguous', label: 'Ambiguous' },
      { value: 'invalid', label: 'Invalid' }
    ];

    this.redoReasons = [
      { value: 'PCR_NTC contamination', label: '01 - PCR_NTC contamination' },
      { value: 'PCR_PC negative', label: '02 - PCR_PC negative' },
      { value: 'PCR_PC Out of range', label: '03 - PCR_PC Out of range' },
      { value: '384 ICR failure (random over all 4 plates)', label: '04 - 384 ICR failure (random over all 4 plates)' },
      { value: '96 ICR failure (one plate)', label: '05 - 96 ICR failure (one plate)' },
      { value: 'Sample contamination', label: '06 - Sample contamination' },
      { value: 'POS_EX negative', label: '07 - POS_EX negative' },
      { value: 'NTC_EX contamination', label: '08 - NTC_EX contamination' },
      { value: '96 plate rotated', label: '09 - 96 plate rotated' },
      { value: '96 plate switched', label: '10 - 96 plate switched' },
      { value: 'Other', label: '99 - Other' }
    ];
    this.mapOfStatusSaves.set("BATCH_UPLOADED", "uploadBatch");
    this.mapOfStatusSaves.set("BATCH_RECEIVED", "receiveBatch");
    this.mapOfStatusSaves.set("START_ARTIC_POOLING", "startArticPooling");
    this.mapOfStatusSaves.set("COMPLETE_ARTIC_POOLING", "completeArticPooling");
    this.mapOfStatusSaves.set("START_ARTIC_PURIFICATION", "startArticPurification");
    this.mapOfStatusSaves.set("COMPLETE_ARTIC_PURIFICATION", "completeArticPurification");
    this.mapOfStatusSaves.set("CONTROLS_ADDED", "controlsAdded");
    this.mapOfStatusSaves.set("START_ARTIC_QC", "startArticQC");
    this.mapOfStatusSaves.set("COMPLETE_ARTIC_QC", "completeArticQC");
    this.mapOfStatusSaves.set("START_END_REPAIR", "startEndRepair");
    this.mapOfStatusSaves.set("COMPLETE_END_REPAIR", "completeEndRepair");
    this.mapOfStatusSaves.set("START_LIB_QC", "startLibQC");
    this.mapOfStatusSaves.set("COMPLETE_LIB_QC", "completeLibQC");
    this.mapOfStatusSaves.set("START_cDNA", "startcDNA");
    this.mapOfStatusSaves.set("COMPLETE_cDNA", "completecDNA");
    this.mapOfStatusSaves.set("START_ADAPTER_LIGATION", "startAdapterLigation");
    this.mapOfStatusSaves.set("COMPLETE_ADAPTER_LIGATION", "completeAdapterLigation");
    this.mapOfStatusSaves.set("START_ARTIC_PCR", "startArticPCR");
    this.mapOfStatusSaves.set("COMPLETE_ARTIC_PCR", "completeArticPCR");
    this.mapOfStatusSaves.set("START_NORMALIZATION", "startNormalization");
    this.mapOfStatusSaves.set("COMPLETE_NORMALIZATION", "completeNormalization");
    this.mapOfStatusSaves.set("START_PURIFICATION_2", "startPurification2");
    this.mapOfStatusSaves.set("COMPLETE_PURIFICATION_2", "completePurification2");
    this.mapOfStatusSaves.set("START_LIB_POOLING", "startLibPooling");
    this.mapOfStatusSaves.set("COMPLETE_LIB_POOLING", "completeLibPooling");
    this.mapOfStatusSaves.set("START_TAG_PCR", "startTagPCR");
    this.mapOfStatusSaves.set("COMPLETE_TAG_PCR", "completeTagPCR");
    this.mapOfStatusSaves.set("TRANSFER_SEQUENCING", "transferSequencing");
    this.mapOfStatusSaves.set("COMPLETE_SEQUENCING_RUN", "completeSequencing");
    this.mapOfStatusSaves.set("START_PRIMARY_ANALYSIS", "startPrimaryAnalysis");
    this.mapOfStatusSaves.set("COMPLETE_PRIMARY_ANALYSIS", "completePrimaryAnalysis");
    this.mapOfStatusSaves.set("START_SECONDARY_ANALYSIS", "startSecondaryAnalysis");
    this.mapOfStatusSaves.set("COMPLETE_SECONDARY_ANALYSIS", "completeSecondaryAnalysis");
    this.mapOfStatusSaves.set("START_DATA_REVIEW", "startDataReview");
    this.mapOfStatusSaves.set("READY_FOR_DELIVERY", "readyForDelivery");
    this.mapOfStatusSaves.set("COMPLETED", "delivered");
    this.mapOfStatusSaves.set("START_FINAL_QC", "startFinalQC");
    this.mapOfStatusSaves.set("COMPLETE_FINAL_QC", "completeFinalQC");
    let element = document.getElementById("userID");
    element.focus();

    this.searchFilterList = [
      {label:'Batch Id',value:'BatchId'},
      {label:'Sample Id',value:'SampleId'},
      {label:'External Id',value:'ExternalId'},
      {label:'Library Id',value:'LibraryId'}
    ];
    this.selectedSearchFilter = "BatchId"
    
    // fetch the batch Id from Delivery view
    this.batchIdFromDelivery =  this.activatedRoute.snapshot.params.id;
    if(this.batchIdFromDelivery){
      this.batchToSearch = this.batchIdFromDelivery;
      this.sampleToSearch = '';
      this.searchForBatch();
    }
  }

  startPrimaryAnalysis(status: string){
    this.selectedBatch.startPrimaryAnalysisDateTime = new Date();
    this.selectedBatch.startPrimaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  completePrimaryAnalysis(status: string){
    this.selectedBatch.completePrimaryAnalysisDateTime = new Date();
    this.selectedBatch.completePrimaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  startSecondaryAnalysis(status: string){
    this.selectedBatch.startSecondaryAnalysisDateTime = new Date();
    this.selectedBatch.startSecondaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  completeSecondaryAnalysis(status: string){
    this.selectedBatch.completeSecondaryAnalysisDateTime = new Date();
    this.selectedBatch.completeSecondaryAnalysisPUID = this.puid;
    this.updateBatch(status);
  }
  startDataReview(status: string){
    this.selectedBatch.startDataReviewDateTime = new Date();
    this.selectedBatch.startDataReviewPUID = this.puid;
    this.updateBatch(status);
  }
  readyForDelivery(status: string){
    this.selectedBatch.readyForDeliveryDateTime = new Date();
    this.selectedBatch.readyForDeliveryPUID = this.puid;
    this.updateBatch(status);
    this.commentPopup = false;
  }
  delivered(status: string){
    this.selectedBatch.deliveryCompletionDateTime = new Date();
    this.selectedBatch.deliveryCompletionPUID = this.puid;
    this.updateBatch(status);
  }
  
  completePurification2(status: string){
    this.selectedBatch.completePurification2DateTIme = new Date();
    this.selectedBatch.completePurification2PUID = this.puid;
    this.updateBatch(status);
  }
  startLibPooling(status: string){
    this.selectedBatch.startLibPoolingDateTime = new Date();
    this.selectedBatch.startLibPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  completeLibPooling(status: string){
    this.selectedBatch.completeLibPoolingDateTime = new Date();
    this.selectedBatch.completeLibPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  startTagPCR(status: string){
    this.selectedBatch.startTagPCRDateTime = new Date();
    this.selectedBatch.startTagPCRPUID = this.puid;
    this.updateBatch(status);
  }
  completeTagPCR(status: string){
    this.selectedBatch.completeTagPCRDateTime = new Date();
    this.selectedBatch.completeTagPCRPUID = this.puid;
    this.updateBatch(status);
  }
  transferSequencing(status: string){
    this.selectedBatch.transferSequencingDateTime = new Date();
    this.selectedBatch.transferSequencingPUID = this.puid;
    this.updateBatch(status);
  }
  completeSequencing(status: string){
    this.selectedBatch.completedSequencingDateTime = new Date();
    this.selectedBatch.completedSequencingPUID = this.puid;
    this.updateBatch(status);
    this.commentPopup = false;
  }
  completeEndRepair(status: string){
    this.selectedBatch.completeEndRepairDateTime = new Date();
    this.selectedBatch.completeEndRepairPUID = this.puid;
    this.updateBatch(status);
  }
  startLibQC(status: string){
    this.selectedBatch.startLibQCDateTime = new Date();
    this.selectedBatch.startLibQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeLibQC(status: string){
    this.selectedBatch.completeLibQCDateTime = new Date();
    this.selectedBatch.completeLibQCPUID = this.puid;
    this.updateBatch(status);
    this.commentPopup = false;
  }
  startFinalQC(status: string){
    this.selectedBatch.startFinalQCDateTime = new Date();
    this.selectedBatch.startFinalQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeFinalQC(status: string){
    this.selectedBatch.completeFinalQCDateTime = new Date();
    this.selectedBatch.completeFinalQCPUID = this.puid;
    this.updateBatch(status);
    this.commentPopup = false;
  }
  startcDNA(status: string){
    this.selectedBatch.startcDNADateTime = new Date();
    this.selectedBatch.startcDNAPUID = this.puid;
    this.updateBatch(status);
  }
  completecDNA(status: string){
    this.selectedBatch.completecDNADateTime = new Date();
    this.selectedBatch.completecDNAPUID = this.puid;
    this.updateBatch(status);
  }
  startAdapterLigation(status: string){
    this.selectedBatch.startAdapterLigationDateTime = new Date();
    this.selectedBatch.startAdapterLigationPUID = this.puid;
    this.updateBatch(status);
  }
  completeAdapterLigation(status: string){
    this.selectedBatch.completeAdapterLigationDateTime = new Date();
    this.selectedBatch.completeAdapterLigationPUID = this.puid;
    this.updateBatch(status);
  }
  startArticPCR(status: string){
    this.selectedBatch.startArticPCRDateTime = new Date();
    this.selectedBatch.startArticPCRPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPCR(status: string){
    this.selectedBatch.completeArticPCRDateTime = new Date();
    this.selectedBatch.completeArticPCRPUID = this.puid;
    this.updateBatch(status);
  }
  startNormalization(status: string){
    this.selectedBatch.startNormalizationDateTime = new Date();
    this.selectedBatch.startNormalizationPUID = this.puid;
    this.updateBatch(status);
  }
  completeNormalization(status: string){
    this.selectedBatch.completeNormalizationDateTime = new Date();
    this.selectedBatch.completeNormalizationPUID = this.puid;
    this.updateBatch(status);
  }
  startPurification2(status: string){
    this.selectedBatch.startPurification2DateTIme = new Date();
    this.selectedBatch.startPurification2PUID = this.puid;
    this.updateBatch(status);
  }
  uploadBatch(status: string){
    this.selectedBatch.batchUploadedDateTime = new Date();
    this.selectedBatch.batchUploadedPUID = this.puid;
    this.updateBatch(status);
  }
  receiveBatch(status: string){
    this.selectedBatch.batchReceivedDateTime = new Date();
    this.selectedBatch.batchReceivedPUID = this.puid;
    this.selectedBatch.filterDateTime = new Date();
    this.selectedBatch.deliveryTargetDateTime = this.addBusinessDays(this.selectedBatch.batchReceivedDateTime, 7);
    this.updateBatch(status);
  }
  startArticPooling(status: string){
    this.selectedBatch.startArticPoolingDateTime = new Date();
    this.selectedBatch.startArticPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPooling(status: string){
    this.selectedBatch.completeArticPoolingDateTime = new Date();
    this.selectedBatch.completeArticPoolingPUID = this.puid;
    this.updateBatch(status);
  }
  startArticPurification(status: string){
    this.selectedBatch.startArticPurificationDateTime = new Date();
    this.selectedBatch.startArticPurificationPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticPurification(status: string){
    this.selectedBatch.completeArticPurificationDateTime = new Date();
    this.selectedBatch.completeArticPurificationPUID = this.puid;
    this.updateBatch(status);
  }
  startPurification3(status: string){
    this.selectedBatch.startPurification3DateTIme = new Date();
    this.selectedBatch.startPurification3PUID = this.puid;
    this.updateBatch(status);
  }
  completePurification3(status: string){
    this.selectedBatch.completePurification3DateTIme = new Date();
    this.selectedBatch.completePurification3PUID = this.puid;
    this.updateBatch(status);
  }
  controlsAdded(status: string){
    let lastSample = this.selectedBatch.samples.slice(-1).pop();
    if (!(lastSample.positionRow == 8 && lastSample.prositionCol == 12)) {

      let ntcControl = new CovidSamples();
      ntcControl.barcode = 'KON00_'+this.selectedBatch.batchID + '_NTC';
      ntcControl.positionRow = 7;
      ntcControl.prositionCol = 12;
      let pcControl = new CovidSamples();
      pcControl.barcode = 'KON00_'+this.selectedBatch.batchID + '_PC';
      pcControl.positionRow = 8;
      pcControl.prositionCol = 12;
      this.selectedBatch.samples.push(ntcControl);
      this.selectedBatch.samples.push(pcControl);
    }
    this.selectedBatch.controlsAddedDateTime = new Date();
    this.selectedBatch.controlsAddedPUID = this.puid;

    this.updateBatch(status);
  }
  startArticQC(status: string){
    this.selectedBatch.startArticQCDateTime = new Date();
    this.selectedBatch.startArticQCPUID = this.puid;
    this.updateBatch(status);
  }
  completeArticQC(status: string){
    this.selectedBatch.completeArticQCDateTime = new Date();
    this.selectedBatch.completeArticQCPUID = this.puid;
    this.updateBatch(status);
    this.commentPopup = false;
  }
  startEndRepair(status: string){
    this.selectedBatch.startEndRepairDateTime = new Date();
    this.selectedBatch.startEndRepairPUID = this.puid;
    this.updateBatch(status);
  }
  findControlesDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe(
      result => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Lab not found!', detail: 'Contact Administrator to resolve this issue.' });
          return;
        }
        this.selectedLab = result.data;
        this.posControlsRemaining = this.selectedLab.numberOfPC;
        this.negativeControlRemaining = this.selectedLab.numberOfNC;
        this.posControlsForLab = this.selectedLab.numberOfPC;
        this.negativeControlForLab = this.selectedLab.numberOfNC;
        this.totalPCRControls = this.selectedLab.numberOfPositivePCRControls + this.selectedLab.numberOfNegativePCRControls;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isAllMidplexButtonsDisable(): boolean{
    return  this.selectedBatch.workflowGroup ==='Midplex';
  }

  isSearchEnabled(): boolean {
    return (this.puid != null && this.puid != undefined && this.puid != "" && this.batchToSearch != null && this.batchToSearch != undefined && this.batchToSearch != "");
  }

  batchViewVisbility(event: any) {
    this.batchToSearch = event.data.batchID;
    this.sampleToSearch = '';
    this.searchForBatch();
  }

  searchBatch() {
    this.batchToSearch = this.batchHistoryId;
    this.searchForBatch();
  }

  searchForBatch() {
    if (this.batchToSearch == null || this.batchToSearch == undefined || this.batchToSearch == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
      return;
    }
    this.searchForBatchAction(this.selectedLabId, this.batchToSearch.trim());
  }

  searchForBatchAction(labID: string, batchID: string) {
    
    this.blocked = true;
    this.batchHistoryId = '';
    this.subSender.clear();
    this.subSenderForPlateOne.clear();
    this.subSenderForPlateTwo.clear();
    this.subSenderForPlateThree.clear();
    this.subSenderForPlateFour.clear();
    this.mapOfQCBatchView.clear();
    this.getDataForLabPlanningAndSearch(labID,batchID);
    

  }


  getDataForLabPlanningAndSearch(labID: string, batchID: string) {
    this.blocked = true;
    let batches$ =  this.apgTestingService.getBatchForLabAndBatchId(labID,this.fieldBatchID ,batchID)
    batches$.subscribe(results => {
      if(results.data){
          this.selectedBatch = results.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.setBatchView();
          this.allowCreate = false;
          this.plateViewDataFetched = false;
          this.setTemplateButtonLabel();
          this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
          this.populateBatchHistory();
          this.getActiveTagPlatesFromMDM();
          this.getMapofPlannedTagPlates();
      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with BatchID ' + this.batchToSearch });
      }      this.populateBatchHistory()
      this.setBatchView();
      this.blocked = false;
    },error=>{
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
      this.plateViewDataFetched = false;
      this.setBatchView();
  }

    )
  }


  
  setTagPlate(arg0: any): any {    
    this.selectedTagPlate = '';
    if(this.selectedBatch.plannedTagPlate) {
      this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
    } else {
      this.tags.forEach(tag => {
        if(this.selectedBatch.tagPlateId == tag.value){
          this.selectedTagPlate = this.selectedBatch.tagPlateId;
        }
      })  
    }
  }

  saveBatchData() {
    this.blocked = true;
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.userID = this.puid;
    this.qcSuccessResponse()
   
    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.enteredPassword = "";
          this.enteredPuid = "";
          this.enteredScanPlateBarcode = "";
          if (this.selectedBatch.statusOfTheBatch === "START_TAG_PCR" && !this.selectedBatch.tagPlateBarcode) {

            let indexOfLastTagPlateId = this.tagsList.indexOf(this.selectedBatch.tagPlateId);
            if (indexOfLastTagPlateId == -1) {

              let cacheListForTest = [...this.tagsList];
              cacheListForTest.push(this.selectedBatch.tagPlateId);
              cacheListForTest.sort();

              let indexOfLastTagPlateIdCheck = cacheListForTest.indexOf(this.selectedBatch.tagPlateId);
              this.setTagPlateId(cacheListForTest, indexOfLastTagPlateIdCheck);
            } else {
              this.setTagPlateId(this.tagsList, indexOfLastTagPlateId);
            }
            if(this.selectedBatch.plannedTagPlate){
              this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
            } else {
              this.selectedTagPlate = this.selectedBatch.tagPlateId;
            }
          }

          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
          });
        }
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        this.selectedBatch.statusOfTheBatch = this.refStatusOfPrev;
        this.selectedBatch.previousStatusOfTheBatch = this.refStatusOfPrev;
        this.enteredPassword = "";
        this.enteredPuid = "";
        this.enteredScanPlateBarcode = "";
        if (this.selectedBatch.statusOfTheBatch==="START_TAG_PCR") {
          this.selectedBatch.tagPlateBarcode = "";
          this.selectedBatch.assignTagPlateDateTime=null;
          this.selectedBatch.assignTagPlatePUID="";
        }
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  qcSuccessResponse() {
    if(this.selectedBatch.previousStatusOfTheBatch == 'COMPLETE_ARTIC_QC')
      this.selectedBatch.articQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == 'COMPLETE_LIB_QC')
      this.selectedBatch.libQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == 'READY_FOR_DELIVERY')
      this.selectedBatch.finalQCFailed=false
    else if(this.selectedBatch.previousStatusOfTheBatch == 'COMPLETE_FINAL_QC')
      this.selectedBatch.dataReviewFailed=false
  }

  setTagPlateId(tagPlateArr: any[], index: number){
    if (index + 1 == tagPlateArr.length) {
      this.selectedBatch.tagPlateId = tagPlateArr[0];
    } else {
      this.selectedBatch.tagPlateId = tagPlateArr[index + 1];
    }
  }
  updateBatch(statusOfBatch: string) {
    this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
    this.selectedBatch.statusOfTheBatch = statusOfBatch;
    this.selectedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
  }

  updateListOfBatches() {
    this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe(
      results => {
        this.batches = results.data;
        this.selectedStates = [];
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isPUIDPresnt() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  onApplyFilter() {
    this.loading = true;
    if (this.selectedStates.length == 0 && !this.fromDate && !this.toDate) {
      this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe(
        results => {

          this.batches = results.data;
          this.loading = false;
        },
        error => {
          this.loading = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
    }
    else {
      let toFilterDate: Date;
      if (!this.fromDate && !this.toDate && this.selectedStates.some( ai => APGCovid19Constants.terminatingStates.includes(ai))) {
        this.toDate = new Date();
        this.fromDate = new Date();
        this.fromDate.setDate(this.toDate.getDate() - 14);
      }
      let selectedStatusList = this.getStatusList();
      if(this.toDate){
        toFilterDate = new Date(this.toDate.getTime());
        toFilterDate.setDate(toFilterDate.getDate() + 1)
      }
      this.apgTestingService.filterBatchesForSamplesMenu(selectedStatusList, this.selectedLabId, !this.fromDate ? '' : this.fromDate.toDateString(), !this.toDate ? '' : toFilterDate.toDateString(), 'ARTIC').subscribe(
        results => {
          this.loading = false;
          this.batches = results.data;
        },
        error => {
          this.loading = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
    }
  }

  private getStatusList() {
    if (this.selectedStates && this.selectedStates.length != 0)
      return this.selectedStates.join(",");
    else {
      let nonTerminatingStates = [];
      this.filterOptions.forEach(option => {
        if (!APGCovid19Constants.terminatingStates.includes(option.value))
          nonTerminatingStates.push(option.value);
      });
      return nonTerminatingStates.join(",");
    }
  }

  setBatchView() {
    this.showPlateView = false;
  }

  getViewPlateIcon(plateViewStatus: boolean) {
    if (this.showPlateView) {
      return 'fa fa-list-alt';
    } else {
      return 'fa fa-th';
    }
  }

  togglePlateView() {
    this.analysisPlateView = this.selectedBatch.resultsImported;
    if(this.showPlateView)
      this.selectedBatch = this.plateViewCmp.onChange();
    this.showPlateView = !this.showPlateView;
    if (this.selectedBatch && (this.selectedBatch.wellType == WellType.WELL96) && this.showPlateView) {
      this.sameScanBatch = false;
      this.scanBlock = true;
    }
  }

  uploadDisabledStatus() {
    if (this.selectedBatch != undefined && this.selectedBatch != null && this.selectedBatch.completenessCheckDateTime != null &&
      this.selectedBatch.completenessCheckDateTime != undefined && this.selectedBatch.puidController2 != null && this.selectedBatch.puidController2 != undefined && this.selectedBatch.puidController2 != '') {
      return true;
    }
    else if (this.isUploadDisabled)
      return true;
    else
      return false;
  }


  disableTDInputsIf(state: string) {
    if (state == 'Registration' && !this.selectedBatch.statusOfTheBatch && this.batchToSearch)
      return false;
    let enabledStates: Array<string> = this.mapOfStatus.get(state);
    if (enabledStates.indexOf(this.selectedBatch.statusOfTheBatch) != -1)
      return false;
    return true;
  }
  

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }


  saveBatchStatus(status: string) {
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.saveBatchStatusAction(status);
        },
        reject: () => { }
      });
    } else {
      this.saveBatchStatusAction(status);
    }
  }

  saveBatchStatusAction(status: string) {
    let functionName = this.mapOfStatusSaves.get(status);
    this[functionName](status);
  }

  saveComment() {
    if (!this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }

    this.blocked = true;
    this.newComment.commentDate = new Date();
    this.newComment.userComment = this.newComment.userComment.trim();
    this.selectedBatch.comments.push(this.newComment);
    this.apgTestingService.saveComment(this.selectedBatch.batchID, this.selectedLabId, this.selectedBatch.comments).subscribe(
      result => {
        this.selectedBatch = result.data;
        this.previewComment = this.newComment;
        let cmnt = this.getArrayOfCommentsToAnother(this.selectedBatch.batchID, this.newComment);
        this.commentsMap.set(this.selectedBatch.batchID, cmnt);
        this.batchCommentVisibility.set(this.selectedBatch.batchID, true);
        this.newComment = this.initializeNewComment();
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  showCompletedStatus() {
    return this.selectedBatch.statusOfTheBatch == 'COMPLETED';
  }

  showConfirmDialogForExcelUpload(uploadError: any, formData: FormData) {
    
    this.confirmationService.confirm({
      message: uploadError.error.bbApiError.message,
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        formData.set('initialValidationCall', 'false');

        this.apgTestingService.uploadExcelSheet(formData).subscribe(
          result => {
            if (!result) {
              return;
            }
            this.plateViewDataFetched = false;
            this.selectedBatch = result.data;
            this.previewComment = this.getPreviewComment(this.selectedBatch);
            this.commentsMap = new Map<string, Comment[]>();
            this.differentUnboxedErrorDisabled = false;
            this.selectedBatch.excelUploadCreatedAt = new Date();
            this.selectedBatch.excelUploadCreatedBy = this.puid;
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Uploaded', detail: 'Upload Successful' });

          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        )
      },
      reject: () => {
      }
    });
    this.isUploadDisabled = true;
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'View Batch';
    } else {
        return 'View Plate';
    }
  }

  setTemplateButtonLabel() {
    if (['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch))
      this.showFilledTemplateLabel = false;
    else
      this.showFilledTemplateLabel = true;
  }

  getPreviewComment(batch: Covid19Batch) {
    let comment = new Comment();
    if (batch.comment && (!batch.comments || batch.comments.length == 0)) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
      batch.comments.push(comment);
    }

    if (batch.comments && batch.comments.length > 0) {
      comment = batch.comments[batch.comments.length - 1];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }

  showComments() {
    this.formCommentsMap(this.selectedBatch.comments);
    this.newComment = this.initializeNewComment();

    this.showCommentDialog = true;
  }

  isCommentAdditionDisabled() {
    return (!this.selectedBatch || !this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '');
  }

  formCommentsMap(comments: Comment[]) {
    if (!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach(comment => {
      let cmnt = this.getArrayOfCommentsToAnother(comment.batchId, comment);
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  getCommentKeys(commentMap: Map<string, Comment[]>) {
    return Array.from(commentMap.keys());
  }

  initializeNewComment() {
    let comment = new Comment();
    comment.batchId = this.selectedBatch.batchID;
    comment.puid = this.puid;

    return comment;
  }

  getArrayOfCommentsToAnother(batchID: string, comment: Comment) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }

  populateSenders() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      (result) => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfSenders.set(key, value);
          });
        }
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  

  populateBatchHistory() {

    let sourceBatchIds = this.selectedBatch.wellType == 'WELL384' ? this.selectedBatch.sourceBatchIds.join(",") : '';
    this.apgTestingService.getBatchHistory(this.selectedBatch.lab, this.selectedBatch.batchID, this.selectedBatch.wellType, sourceBatchIds).subscribe(
      result => {
        this.batchHistory = [];
        this.groupedBatches = [];
        if (result.data) {
          if (this.selectedBatch.wellType == 'WELL384') {
            let groupLabel = '';
            Object.entries(result.data).forEach(([key]) => {
              let batchGroup = new BatchGroup();
              let batcheIds = result.data[key];
              batcheIds.forEach((element: string) => {
                if (this.selectedBatch.sourceBatchIds.includes(element)) {
                  groupLabel = element;
                }
              });
              batchGroup.label = groupLabel;
              result.data[key].forEach((element: string) => {
                let batchItems = new BatchItemHistory();
                batchItems.label = element;
                batchItems.value = element;
                batchGroup.items.push(batchItems);
              });

              this.groupedBatches.push(batchGroup);
            });
          } else {
            result.data.forEach(batch => {
              this.batchHistory.push({label: batch, value: batch});
            });
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getStatus(){
    if(this.selectedBatch.statusOfTheBatch && this.selectedBatch.statusOfTheBatch == 'REDO')
      return this.selectedBatch.statusOfTheBatch + '     By: ' + this.selectedBatch.redoPUID + '  ' + this.datepipe.transform(this.selectedBatch.redoDateTime, this.selectableLab.lab.dateTimeFormat);
    else
      return this.selectedBatch.statusOfTheBatch
  }

  onFLXUpload(event, fileUploader: any){
    this.selectedBatch.excelUploadCreatedAt = new Date();
    this.selectedBatch.excelUploadCreatedBy = this.puid;
    const formData = new FormData();
    formData.append('file', event.files[0]);
    formData.append('labId', this.selectedLabId);
    formData.append('batchID', this.selectedBatch.batchID);
    formData.append('statusOfTheBatch', this.selectedBatch.statusOfTheBatch);
    formData.append('puid', this.puid);
    formData.append('resultUploaded', this.selectedBatch.statusOfTheBatch == 'START_ARTIC_QC' ? this.selectedBatch.articQCResultUploaded.toString() : this.selectedBatch.libQCResultUploaded.toString());
    formData.append('diluated', this.selectedBatch.statusOfTheBatch == 'START_ARTIC_QC' ? this.dillusionFactorForArticQC.toString() : this.dillusionFactorForLibQC.toString());
    this.blocked = true;
    this.apgTestingService.uploadFLXFile(formData).subscribe(
      result => {
        if (!result) {
          return;
        }
        fileUploader.clear();
        this.selectedBatch = result.data;
        this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'FLX file has been uploaded successfully' });
      },
      error => {
        fileUploader.clear();
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  getFileUploadStyle() {
    return {
      'margin-bottom': '5px',
      'margin-top': '5px',
      'font-weight': 'bold',
      'font-size': '14px',
      'padding': '7px 0px 7px 0px',
      'width': '96%',
      'border-radius': '5px',
      'background-color': '#0072bc',
      'border': 'none'
    }
  }

  disableReceiveBatch() {
    return !(this.selectedBatch.excelUploadCreatedAt && this.selectedBatch.excelUploadCreatedBy);
  }

  disableStartArticPooling(){
    return !(this.selectedBatch.completeArticPCRDateTime && this.selectedBatch.completeArticPCRPUID);
  }

  disableCompleteArticPooling(){
    return !(this.selectedBatch.startArticPoolingDateTime && this.selectedBatch.startArticPoolingPUID)
  }

  disableStartPurification1(){
    return !(this.selectedBatch.completeArticPoolingDateTime && this.selectedBatch.completeArticPoolingPUID)
  }

  disableCompletePurification1(){
    return !(this.selectedBatch.startArticPurificationDateTime && this.selectedBatch.startArticPurificationPUID)
  }

  disableStartPurification3(){
    return !(this.selectedBatch.completeTagPCRDateTime && this.selectedBatch.completeTagPCRPUID)
  }

  disableCompletePurification3(){
    return !(this.selectedBatch.startPurification3DateTIme && this.selectedBatch.startPurification3PUID)
  }

  disableControlsAdded(){
    return !(this.selectedBatch.batchReceivedDateTime && this.selectedBatch.batchReceivedPUID)
  }

  disableStartArticQC(){
    return !(this.selectedBatch.completeArticPurificationDateTime && this.selectedBatch.completeArticPurificationPUID)
  }

  disableCompleteArticQC(){
    return !(this.selectedBatch.measuredArticQCDateTime && this.selectedBatch.measuredArticQCPUID)
  }

  disableStartEndRepair(){
    return !(this.selectedBatch.completeNormalizationDateTime && this.selectedBatch.completeNormalizationPUID)
  }

  disableCompleteEndRepair(){
    return !(this.selectedBatch.startEndRepairDateTime && this.selectedBatch.startEndRepairPUID)
  }

  disableStartLibQC(){
    return !(this.selectedBatch.completeTagPCRDateTime && this.selectedBatch.completeTagPCRPUID)
  }

  disableCompleteLibQC(){
    return !(this.selectedBatch.measuredLibQCDateTime && this.selectedBatch.measuredLibQCPUID)
  }

  disableStartcDNA(){
    return !(this.selectedBatch.controlsAddedDateTime && this.selectedBatch.controlsAddedPUID)
  }

  disablecDNAWorkFile(){
    return !(this.selectedBatch.startcDNADateTime && this.selectedBatch.startcDNAPUID)
  }
  disableCompletecDNA(){
    return !(this.selectedBatch.cDNAWorkfileDateTime && this.selectedBatch.cDNAWorkfilePUID)
  }

  disableStartAdapterLigation(){
    return !(this.selectedBatch.completeEndRepairDateTime && this.selectedBatch.completeEndRepairPUID)
  }

  disableCompleteAdapterLigation(){
    return !(this.selectedBatch.startAdapterLigationDateTime && this.selectedBatch.startAdapterLigationPUID)
  }

  disableStartArticPCR(){
    return !(this.selectedBatch.completecDNADateTime && this.selectedBatch.completecDNAPUID)
  }

  disableCompleteArticPCR(){
    return !(this.selectedBatch.startArticPCRDateTime && this.selectedBatch.startArticPCRPUID)
  }

  disableStartNormalization(){
    return !(this.selectedBatch.completeArticQCDateTime && this.selectedBatch.completeArticQCPUID)
  }

  disableCompleteNormalization(){
    return !(this.selectedBatch.startNormalizationDateTime && this.selectedBatch.startNormalizationPUID)   
  }

  disableStartPurification2(){
    return !(this.selectedBatch.completeAdapterLigationDateTime && this.selectedBatch.completeAdapterLigationPUID)   
  }

  disableCompletePurification2(){
    return !(this.selectedBatch.startPurification2DateTIme && this.selectedBatch.startPurification2PUID)   
  }

  disableStartLibPooling(){
    return !(this.selectedBatch.completeTagPCRDateTime && this.selectedBatch.completeTagPCRPUID)   
  }

  disableCompleteLibPooling(){
    return !(this.selectedBatch.startLibPoolingDateTime && this.selectedBatch.startLibPoolingPUID)   
  }

  disableStartTagPCR() {
      return !((this.selectedBatch.completePurification2DateTIme && this.selectedBatch.completePurification2PUID) || (this.selectedBatch.completeNormalizationDateTime && this.selectedBatch.completeNormalizationPUID))
  }

  disableAssignTagPlate(){
    return !(this.selectedBatch.startTagPCRDateTime && this.selectedBatch.startTagPCRPUID && this.selectedTagPlate)   
  }
  
  disableCompleteTagPCR(){
    return !(this.selectedBatch.assignTagPlateDateTime && this.selectedBatch.assignTagPlatePUID)   
  }

  disableTransferSequencing(){
    return !(this.selectedBatch.completeFinalQCDateTime && this.selectedBatch.completeFinalQCPUID)   
  }

  disableCompleteSequencing(){
    return !(this.selectedBatch.transferSequencingDateTime && this.selectedBatch.transferSequencingPUID)   
  }

  disableStartPrimaryAnalysis(){
    return !(this.selectedBatch.completedSequencingDateTime && this.selectedBatch.completedSequencingPUID)  || 
    (this.selectedBatch.startPrimaryAnalysisDateTime && this.selectedBatch.startPrimaryAnalysisPUID)   
  }

  disableCompletePrimaryAnalysis(status: string[]){

    return (!status.includes(this.selectedBatch.statusOfTheBatch) ) &&
    !(this.selectedBatch.startPrimaryAnalysisDateTime && this.selectedBatch.startPrimaryAnalysisPUID)   
   || (this.selectedBatch.completePrimaryAnalysisDateTime && this.selectedBatch.completePrimaryAnalysisPUID) 

  }

  disableStartSecondaryAnalysis(status: string[]){
    return (!status.includes(this.selectedBatch.statusOfTheBatch) ) &&
     !(this.selectedBatch.startPrimaryAnalysisDateTime && this.selectedBatch.startPrimaryAnalysisPUID) 
    || (this.selectedBatch.startSecondaryAnalysisDateTime && this.selectedBatch.startSecondaryAnalysisPUID) 
  }

  disableStartSecondary() {
    
    return (this.selectedBatch.completeSecondaryAnalysisDateTime && this.selectedBatch.completeSecondaryAnalysisPUID) 
    
  }
  disableCompleteSecondaryAnalysis(status: string[]){
  
    return (!status.includes(this.selectedBatch.statusOfTheBatch) ) &&
    !(this.selectedBatch.startSecondaryAnalysisDateTime && this.selectedBatch.startSecondaryAnalysisPUID)    
   || (this.selectedBatch.completeSecondaryAnalysisDateTime && this.selectedBatch.completeSecondaryAnalysisPUID) 
   }

  disableStartDataReview(){
    return !(this.selectedBatch.completePrimaryAnalysisDateTime && this.selectedBatch.completePrimaryAnalysisPUID 
       && this.selectedBatch.completeSecondaryAnalysisDateTime && this.selectedBatch.completeSecondaryAnalysisPUID)   
  }

  disableCompleteDataReview(){
    return !(this.selectedBatch.startDataReviewDateTime && this.selectedBatch.startDataReviewPUID)   
  }

  disableDelivered(){
    return !(this.selectedBatch.startDeliveryDateTime && this.selectedBatch.startDeliveryPUID)   
  }

  disableStartFinalQC(){
    return !(this.selectedBatch.completeLibPoolingDateTime && this.selectedBatch.completeLibPoolingPUID)
  }

  disableCompleteFinalQC(){
    return !(this.selectedBatch.startFinalQCDateTime && this.selectedBatch.startFinalQCPUID)
  }
  
  disableIfNoControls(){
    if(this.selectedBatch && this.selectedBatch.controlsAddedDateTime && this.selectedBatch.controlsAddedPUID){
        return false;
    } else{
      return true;
    }
  }

  completeStatus(){
    if(this.selectedBatch.statusOfTheBatch == 'START_ARTIC_QC')
      this.completeArticQC('COMPLETE_ARTIC_QC');
    else if(this.selectedBatch.statusOfTheBatch == 'START_LIB_QC')
      this.completeLibQC('COMPLETE_LIB_QC');
    else if(this.selectedBatch.statusOfTheBatch == 'START_DATA_REVIEW')
      this.readyForDelivery('READY_FOR_DELIVERY');
    else if(this.selectedBatch.statusOfTheBatch == 'START_FINAL_QC')
      this.completeFinalQC('COMPLETE_FINAL_QC');
  }

  redoBatch(status: string) {
    let redoBatch = this.selectedBatch;
    redoBatch.redoStatus = status;
    redoBatch.redoDateTime = new Date();
    redoBatch.redoPUID = this.puid;
    this.blocked = true;
    this.apgTestingService.redoBatchService(redoBatch).subscribe(
      result => {
        if (result.data) {
          this.redoqcBatchfailed(redoBatch)
          this.commentPopup = false;
          this.selectedBatch = result.data;
          if(!['TRANSFER_SEQUENCING','COMPLETE_SEQUENCING_RUN'].includes(status))
            this.selectedTagPlate = '';
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Redo Batch Created!',
            detail: 'Redo Batch ' + result.data.batchID + ' has been created'
          });
        }
        this.blocked = false;
        this.populateBatchHistory()
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        message.summary = 'REDO Error';
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  redoqcBatchfailed(redoBatch: Covid19Batch) {
    if(redoBatch.history){
      let historyCurrentBatch=redoBatch.history[redoBatch.history.length-1]
      this.apgTestingService.getBatchForLabAndBatchId(redoBatch.lab,this.fieldBatchID ,historyCurrentBatch.currentBatch).subscribe(
        result => {
          if(result.data){
            this.redoBatchUpdate(redoBatch,result)
          }
        });
    }
  }
  redoBatchUpdate(redoBatch: Covid19Batch,result: BBResponseContainer) {
    if(['START_ARTIC_QC'].includes(redoBatch.previousStatusOfTheBatch)){
      this.selectedQCFailedBatch=result.data;
      this.selectedQCFailedBatch.redoDateTime = new Date();
      this.selectedQCFailedBatch.redoPUID = this.puid;
      this.selectedQCFailedBatch.currentRedoBatch=result.data.batchID
      this.selectedQCFailedBatch.articQCFailed=true
      this.apgTestingService.saveSampleData(this.selectedQCFailedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe();
   }
   if((['START_LIB_QC'].includes(redoBatch.previousStatusOfTheBatch) || 
   (['START_LIB_QC'].includes(redoBatch.previousStatusOfTheBatch) && ['COMPLETE_ARTIC_QC'].includes(redoBatch.redoStatus)))){
      this.selectedQCFailedBatch=result.data
      this.selectedQCFailedBatch.redoLibQCDateTime = new Date();
      this.selectedQCFailedBatch.redoLibQCPUID = this.puid;
      this.selectedQCFailedBatch.currentRedoBatch=result.data.batchID
      this.selectedQCFailedBatch.libQCFailed=true
      this.apgTestingService.saveSampleData(this.selectedQCFailedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe();
   }
   if((['START_FINAL_QC'].includes(redoBatch.previousStatusOfTheBatch)) ||
   (['START_FINAL_QC'].includes(redoBatch.previousStatusOfTheBatch) && ['COMPLETE_ARTIC_QC'].includes(redoBatch.redoStatus))){
      this.selectedQCFailedBatch=result.data
      this.selectedQCFailedBatch.redoFinalQCDateTime = new Date();
      this.selectedQCFailedBatch.redoFinalQCPUID = this.puid;
      this.selectedQCFailedBatch.currentRedoBatch=result.data.batchID
      this.selectedQCFailedBatch.finalQCFailed=true
      this.apgTestingService.saveSampleData(this.selectedQCFailedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe();
   }
   if((['START_DATA_REVIEW'].includes(redoBatch.previousStatusOfTheBatch) && ['CONTROLS_ADDED'].includes(redoBatch.redoStatus)) ||
      (['START_DATA_REVIEW'].includes(redoBatch.previousStatusOfTheBatch) && ['COMPLETE_ARTIC_QC'].includes(redoBatch.redoStatus)) ||
      (['START_DATA_REVIEW'].includes(redoBatch.previousStatusOfTheBatch) && ['TRANSFER_SEQUENCING'].includes(redoBatch.redoStatus)) ||
      (['START_DATA_REVIEW'].includes(redoBatch.previousStatusOfTheBatch) && ['COMPLETE_SEQUENCING_RUN'].includes(redoBatch.redoStatus))){
          this.selectedQCFailedBatch=result.data
          this.selectedQCFailedBatch.redoDataReviewQCDateTime = new Date();
          this.selectedQCFailedBatch.redoDataReviewQCPUID = this.puid;
          this.selectedQCFailedBatch.currentRedoBatch=result.data.batchID
          this.selectedQCFailedBatch.dataReviewFailed=true
          this.apgTestingService.saveSampleData(this.selectedQCFailedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe();
         }
   }
  populateTags() {

    this.masterDataService.getMapOfTags(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe(
      (result) => {
        if (result.data) {
          this.cachedTags = [];
          this.cachedTagsList = [];
          this.mapOfTags.clear();
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfTags.set(key, value);
            if (this.mapOfTagsFromMDM.has(key)) {
              this.cachedTags.push({ label: key, value: key });
              this.cachedTagsList.push(key);
            }
            this.tags = [...this.cachedTags];
            this.tagsList = [...this.cachedTagsList];
            this.tagObj = this.mapOfTagsFromMDM.get(this.selectedBatch.tagPlateId);
            if (!this.selectedBatch.plannedTagPlate) {
              if (this.selectedBatch.tagPlateId && !this.mapOfTagsFromMDM.has(this.selectedBatch.tagPlateId)) {
                this.tags.push({ label: this.selectedBatch.tagPlateId, value: this.selectedBatch.tagPlateId });
                this.tagsList.push(this.selectedBatch.tagPlateId);
              } else {
                this.selectedTagPlate = this.selectedBatch.tagPlateId;
              }
            } else {

              this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
              this.tags.push({ label: this.selectedBatch.plannedTagPlate, value: this.selectedBatch.plannedTagPlate });
              this.tagsList.push(this.selectedBatch.tagPlateId);
            }
          });
        }
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getSamplePositionString(sample: CovidSamples){
    let position = String.fromCharCode(64 + sample.positionRow);
    if(sample.prositionCol < 10)
      position += '0';
    position += sample.prositionCol;
    return position;
  }
  
  
  downloadFLXWorkFile(){
    this.blocked=true;
    this.apgTestingService.downloadFLXWorkFile(this.selectedBatch.batchID, this.selectedLabId).subscribe(
      results => {
        
        var blob = new Blob([results.fileContent], { type: 'text/plain' });
        this.saveFile(blob, "FLX_" + this.selectedBatch.batchID + ".txt");
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'FLX Work file has been downloaded',
        });
        this.blocked=false;
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Download Failed',
          detail: 'Could not download FLX Work file.',
        });
      });
  }

  onFLXFileSelect(event){
    if(event.files[0].name.split('.').pop() != "txt"){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only Text files are allowed.',
      });
    }
  }

  verifyReceptionPUIDAction(vrEnteredScanPlateBarcode:string, vrPUID: string, vrPassword: string) {
     this.verifyReception(vrEnteredScanPlateBarcode,vrPUID, vrPassword);
  }

  openVerifyReceptionPopup() {
    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredScanPlateBarcode = "";
    this.enteredPasswordToByeArray = [];
    setTimeout(() => {
      this.searchElement1.nativeElement.focus();
    }, 1000);
    this.verifyReceptionPUID = true;
  }

  verifyReception (vrTagPlateName: string, vrPUID: string, vrPassword: string) {
    this.verifyReceptionPUID = false;
    var password = this.convertStringToUTF8ByteArray(vrPassword);
    this.assignTagPlateName('START_TAG_PCR',vrTagPlateName, vrPUID, password);
    }

  assignTagPlateName(startTagPCR: string, vrTagPlateName:string, vrPUID: string, vrPassword: any[]) {
    
    if(this.mapOfTagsFromMDM.has(this.selectedTagPlate) || this.selectedBatch.plannedTagPlate){      
      if (this.selectedBatch.plannedTagPlate) {
        this.assignTagPlateNameForPlannedTagPlates(startTagPCR, vrTagPlateName, vrPUID, vrPassword);
      } else {
        this.tagObj = this.mapOfTagsFromMDM.get(this.selectedTagPlate);
        let tag = this.tagObj.tagPlateBarcode;
        if(!tag.includes(vrTagPlateName)){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Invalid Plate Barcode!!',
            detail: 'Tag Plate Barcode not configured in MDM for the selected Tag Plate.',
          });
          return;
        }   
      }
      
    } else{
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Plate Selected!!',
        detail: 'Selected Tag Plate has been inactivated in MDM. Please change or re-activate the Tap Plate',
      });
      return;
    }

    if (!this.selectedBatch.plannedTagPlate) {
      this.getTagPlateForPlannedBatches(startTagPCR,vrTagPlateName,vrPUID,vrPassword, this.tagObj.runPlanningSequence);
    }
  }

   assignTagPlateNameForPlannedTagPlates(startTagPCR: string, vrTagPlateName: string, vrPUID: string, vrPassword: any[]) {
  
        this.tagObj = this.mapOfPlannedTags.get(this.selectedTagPlate);
        let tag = this.tagObj.tagPlateBarcode;
        if(!tag.includes(vrTagPlateName)){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Invalid Plate Barcode!!',
            detail: 'Tag Plate Barcode not configured in MDM for the selected Tag Plate.',
          });
          return;
        }
        this.getTagPlateForPlannedBatches(startTagPCR,vrTagPlateName,vrPUID,vrPassword, this.tagObj.runPlanningSequence);    

  }

  getTagPlateForPlannedBatches(startTagPCR: string, vrTagPlateName:string, vrPUID: string, vrPassword: any[], runPlanningSequence: string) {
    this.selectedBatch.assignTagPlateDateTime = new Date();
    this.selectedBatch.assignTagPlatePUID = vrPUID.substring(0,vrPUID.indexOf('@'));
    this.selectedBatch.tagPlateBarcode = vrTagPlateName;
    this.selectedBatch.username = vrPUID;
    this.selectedBatch.password = vrPassword;
    this.selectedBatch.tagRunPlanningSequence = runPlanningSequence;
    this.selectedBatch.eventForAuthorization = true;
    this.selectedBatch.tagPlateId = this.selectedTagPlate;
    if ((this.selectedBatch.assignTagPlatePUID.toLowerCase() != this.puid.toLowerCase())) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Verification Failed!',
        detail: 'Username should be same as Logged in user',
      });
      this.selectedBatch.assignTagPlateDateTime=null;
      this.selectedBatch.assignTagPlatePUID=null;
      this.selectedBatch.tagPlateBarcode=null;
      this.selectedBatch.tagPlateId=null;
      return;
    }
    if(this.selectedBatch.tagPlateId && this.selectedBatch.tagPlateId.trim() != ''){
      let tagPlate = this.mapOfTags.get(this.selectedBatch.tagPlateId)
      if (tagPlate) {
        for(let sample of this.selectedBatch.samples) {
          let position = this.getSamplePositionString(sample);
          let tag = tagPlate[position];
          if(tag != null && tag != undefined){
            sample.tagPlateId = tag.tagPlate;
            sample.u7Sequence = tag.u7Sequence;
            sample.u5Sequence = tag.u5Sequence
          } else {

            this.errorBlock();
            return;
          }
        }
      } else {

        this.errorBlock();
        return;
      }

    }
      this.updateBatch(startTagPCR);
  }

  convertStringToUTF8ByteArray(str) {
    var data = [];
    for (var i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  getActiveTagPlatesFromMDM() {
    this.masterDataService.getMapOfTagsFromMDM(this.selectedLabId, this.selectedBatch.tagSystemName).subscribe(
      (result) => {
        if (result.data) {
          this.mapOfTagsFromMDM = new Map(Object.entries(result.data))
  
        }
        this.populateTags();
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  downloadDNAWorkFile() {
    
    this.blocked = true;
      this.apgTestingService.downloadDNAWorkFile(this.selectedBatch.batchID,this.selectedBatch.lab).subscribe(
      
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating lynx workfile download',
            detail: '',
          });
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
          let fileTxt: string = "Plate_"+this.selectedBatch.batchID + "_Vol_DNA.csv"
          saveByFileSaver(blobTxt, fileTxt);
          this.searchForBatchAction(this.selectedBatch.lab,this.selectedBatch.batchID);
          this.blocked = false;
        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }      
      )
  
}

downloadBufferWorkFile(){
  this.blocked = true;
  this.apgTestingService.downloadBufferWorkFile(this.selectedBatch.batchID,this.selectedBatch.lab).subscribe(
      
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating lynx workfile download',
          detail: '',
        });
        let txtData = result.data;
        let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
        let fileTxt: string = "Plate_"+this.selectedBatch.batchID + "_Vol_Buffer.csv"
        saveByFileSaver(blobTxt, fileTxt);
        this.searchForBatchAction(this.selectedBatch.lab,this.selectedBatch.batchID);
        this.blocked = false;

      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
    
}

getRunInformation(): string{
  let runInfo = 'Run ID: ';
  let lastRun: RunLane = this.selectedBatch.runAndLaneIdInfo[this.selectedBatch.runAndLaneIdInfo.length - 1];
  runInfo += lastRun.runId + ' Lane: ' + lastRun.laneId;
  return runInfo;
}

getStartRunDateTime() {
  let lastRun: RunLane = this.selectedBatch.runAndLaneIdInfo[this.selectedBatch.runAndLaneIdInfo.length - 1];
  return lastRun.runSequencingDateTime;
}

enableIfStatusIn(status: string[]){
  return !status.includes(this.selectedBatch.statusOfTheBatch)
}


searchForBatchWIthFilter(){
  if(!this.valueToSearch || this.valueToSearch.trim() ==''){
    this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
    return;
  }
  this.getDataForLabPlanning();
}

getDataForLabPlanning() {
  this.blocked = true;
  let batches$ = this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId , this.selectedSearchFilter, this.valueToSearch.trim() );
  batches$.subscribe(results => {
    if(results.data){
      this.selectedBatch = results.data;
      this.showMessageForSearchBatch();
      this.previewComment = this.getPreviewComment(this.selectedBatch);
        this.commentsMap = new Map<string, Comment[]>();
      this.valueToSearch = '';
      this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
      this.getActiveTagPlatesFromMDM();
      this.getMapofPlannedTagPlates();
    } else {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with '+this.selectedSearchFilter +' '+ this.valueToSearch });
    }      this.populateBatchHistory()
    this.setBatchView();
    this.blocked = false;
  },error=>{
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
    this.setBatchView();
    }

  )
}




selectedPlannedTag(arg0: any, arg1: any): any {
  if(!this.selectedBatch.plannedTagPlate) {
    if(this.selectedBatch.tagPlateId && !this.mapOfTagsFromMDM.has(this.selectedBatch.tagPlateId)){
      this.tags.push({label:this.selectedBatch.tagPlateId, value: this.selectedBatch.tagPlateId});
      this.tagsList.push(this.selectedBatch.tagPlateId);
    } else {
      this.selectedTagPlate  = this.selectedBatch.tagPlateId; 
    }
  } else {
    
    this.selectedTagPlate = this.selectedBatch.plannedTagPlate;
    this.tags.push({label:this.selectedBatch.plannedTagPlate, value: this.selectedBatch.plannedTagPlate});
    this.tagsList.push(this.selectedBatch.tagPlateId);
  }

}

  showMessageForSearchBatch(): any {
    if(this.selectedBatch.workflowGroup != null && this.selectedBatch.workflowGroup === 'Midplex'){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Midplex Batch found!', detail: 'Batch '+this.selectedBatch.batchID+' is a Midplex batch that can not be processed on this page'});
          }
   else if(this.selectedBatch.matchedBatchCount == 1){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Batch Found!',
        detail: 'Batch for ' + this.valueToSearch + ' is Found.'});
    }else if([2,3,4,5].includes(this.selectedBatch.matchedBatchCount)){
      this._messagesService.addWarningMessage({ 
      severity: 'warn',
      summary: 'Multiple Batchs Found', 
      detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount+' Batch Id\'s are : '
      +this.selectedBatch.matchedBatchIDs});
    }else if(this.selectedBatch.matchedBatchCount>1) { 
      this._messagesService.addWarningMessage({ 
        severity: 'warn',
        summary: 'Multiple Batchs Found', 
        detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount}); 
    }
  }


  createPoolIdForTheBatch() {
    let covid19Batch = this.selectedBatch;
    covid19Batch.type = "Artic";
    this.blocked = true;
    this.apgTestingService.createPoolIdForTheBatch(covid19Batch).subscribe(
      result => {
        let srResponse = result.data;
        covid19Batch.nglimsSampleCreationPUID = this.puid;
        covid19Batch.nglimsSampleCreationDateTime = new Date();
        covid19Batch.nglimsProjectId = covid19Batch.coProjectId;
        covid19Batch.nglimsSampleId = covid19Batch.batchID.substring(covid19Batch.batchID.split('_', 2).join('_').length + 1, covid19Batch.batchID.length);;
        covid19Batch.libraryId = srResponse.barcode;
        covid19Batch.mintUUID = srResponse.libraryId;
        this.saveNGLIMSBatchData(covid19Batch);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Batch Sample created on MINT',
          detail: 'Sample : '+ srResponse.barcode+ " " + ', Project : '+ covid19Batch.coProjectId ,
        });
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let apiErrormessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(apiErrormessage);
      }
    )

  }

  getPlannedRead(): number {
    if(this.selectedBatch.requiredRead && this.selectedBatch.requiredRead!= 0){
      return this.selectedBatch.requiredRead
    } 
    return 500000;
  }
  searchButtonDisabledIf(){
    return !(this.selectedSearchFilter && this.valueToSearch && this.valueToSearch.trim() != '' );
  }

  getAnalysisButtonLabel(){
    return !this.analysisPlateView ? 'Analysis Plate View' : 'Lab Plate View';
  }

  toggleAnalysisView(){
    this.analysisPlateView = !this.analysisPlateView;
    this.plateViewCmp.toggelAnalysisView();
  }

  getDropdownStyle(){
    let style = {
      'height': '100%',
      'font-weight': 'bold',
      'width': '88%',
    };
    if(this.showFilter)
      style['font-size'] = '90%';
    else
      style['font-size'] = '115%';
    return style;
  }

  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }
  assignButtonDisabled(){
    return !((this.enteredPassword && this.enteredPassword.trim()!='')&&(this.enteredPuid && this.enteredPuid.trim()!='')&&(this.enteredScanPlateBarcode && this.enteredScanPlateBarcode.trim()!=''));
  }

  getfunction(){
    if(this.selectedBatch.sender){
      if(this.selectedBatch.sender.length <= 21){
        return this.selectedBatch.sender
      }else if(this.selectedBatch.sender.length > 21){
        return this.selectedSender.senderShortName 
      }
    }
  }

  disableCastDropdown() {
    return (this.selectedBatch.plannedTagPlate);
  }

  disableCreateSampleButton(){
    return !( (!this.disableCompleteTagPCR() || this.selectedBatch.plannedTagPlate) && !this.selectedBatch.nglimsProjectId);
    }


    getBatchViewForQCReport(lab:string , batchID:string) {
      this.blocked = true;
      this.apgTestingService.getBatchViewForQCReport(lab, batchID).subscribe(
        result => {
          if (result.data) {
            Object.entries(result.data).forEach(([key, value]) => {
              this.mapOfQCBatchView.set(key, value);
            });
          }
          this.blocked =false;
        },
        error => {

          this.blocked=false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    }
    createProcessBatch(status: string){
      if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
        return;
      }
      if (!this.isPUIDPresnt()) {
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
        return;
      }
      let processBatch = this.selectedBatch;
      
      if(this.selectedBatch.controlsAddedDateTime){
        this.processBatchControl=true
      }else{
        processBatch.shuffledoriginalBatchID=this.selectedBatch.batchID
        this.processBatchControl=false
      }
     
      processBatch.statusOfTheBatch = status;
      processBatch.controlsAddedDateTime = new Date();
      processBatch.controlsAddedPUID = this.puid;
      processBatch.processBatch=true;
      if(this.selectedBatch.batchRenameEarly){
         processBatch.comments=[];
      }
      this.blocked = true;
      this.apgTestingService.createProcessBatch(processBatch,this.processBatchControl).subscribe(
        result => {
          if (result.data) {
            this.selectedBatch = result.data;
            this.blocked = false;
            this.populateBatchHistory()
            this.previewComment = this.getPreviewComment(this.selectedBatch);
          }
        },
        error => {
          this.blocked = false;
          this.selectedBatch.controlsAddedDateTime=null;
          this.selectedBatch.controlsAddedPUID=null;
          let message = this.errorHandler.handleError(error);
          message.summary = 'Process Batch Creation Error';
          this._messagesService.addErrorMessage(message);
        }
      );
    }

    getNTCAndSamplePosition(){
      let ntcposition=""
      this.pcrPosition=""
      if(this.selectedBatch && this.selectedBatch.samples){
        let ntcSample  = this.selectedBatch.samples.filter(sample => (sample.ntcControl && sample.ntcControl == "C"));
        if(ntcSample && ntcSample.length>0){
          let ntcChar = this.rowHeaders[(ntcSample[0].positionRow) - 1];
          let pcChar = this.rowHeaders[(ntcSample[0].positionRow)];
          ntcposition= ntcChar+ntcSample[0].prositionCol +": NTC  G12: sample from "+ntcChar+ntcSample[0].prositionCol 
          this.pcrPosition= pcChar+ntcSample[0].prositionCol +": PC   H12: sample from "+pcChar+ntcSample[0].prositionCol 
        }
      }
      return ntcposition;
    }
    getPCAndSamplePosition(){
      return this.pcrPosition;
    }
    downloadcDNAControlsWorkFile() {
      this.selectedBatch.cDNAWorkfileDateTime= new Date();
      this.selectedBatch.cDNAWorkfilePUID = this.puid;
      this.saveBatchData();
       this.blocked = true;
         this.apgTestingService.downloadcDNAControlsWorkFile(this.selectedBatch).subscribe(
           result => {
             this._messagesService.addSuccessMessage({
               severity: 'success', summary: 'Intiating cDNA workfile download',
               detail: '',
             });
             let txtData = result.data;
             let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
             let fileTxt: string = this.selectedBatch.batchID+"_ARTIC_cDNA_Rx_Setup_Worklist" +".csv"
             saveByFileSaver(blobTxt, fileTxt);
             this.blocked = false;
             },
             error => {
               let message = this.errorHandler.handleError(error);
               this._messagesService.addErrorMessage(message);
             })     
     }

    getChangedValue(mapOfReview) {
      this.dirtyChild = mapOfReview["dirtyChild"];
    }
  
  getMapofPlannedTagPlates(){
    this.masterDataService.getMapOfTagsFromMDMForPlannedTagPlates(this.selectedLabId,this.selectedBatch.tagSystemName,true).subscribe(
      (result) => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfPlannedTags.set(key, value);
          });
        }
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }


  saveNGLIMSBatchData(nglimsBatchData:any) {
    this.blocked = true;
    nglimsBatchData.lab = this.selectedLabId;
    nglimsBatchData.userID = this.puid;
    this.apgTestingService.saveSampleData(nglimsBatchData, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        if (result.data) {
          if(this.selectedBatch.batchID==nglimsBatchData.batchID){
           this.selectedBatch=result.data;
            this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
            });
          }
        }
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  
  errorBlock() {
    this._messagesService.addErrorMessage({
      severity: 'error', summary: 'Tag not present!',
      detail: 'Failed to fetch the tag, Please connect with blueberry support',
    });
    this.selectedBatch.assignTagPlateDateTime=null;
    this.selectedBatch.assignTagPlatePUID=null;
    this.selectedBatch.tagPlateBarcode=null;
    this.selectedBatch.tagPlateId=null;

  }
}